import { create } from 'zustand';

export type RightPanelName = 'layers' | 'news' | 'ai' | 'cart';

interface RightPanelsStore {
  openPanel: RightPanelName | null;
  setOpenPanel: (panel: RightPanelName | null) => void;
}

export const useRightPanelsStore = create<RightPanelsStore>((set) => ({
  openPanel: null,
  setOpenPanel: (panel) => set({ openPanel: panel }),
}));
